import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { AlertService } from 'src/app/helper/service/alert.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { WHATSAPP_SEND } from 'src/app/modules/patients/helper/patient-form';
import { FormGeneratorComponent } from '../../form/component/form-generator/form-generator.component';
import { ModalService } from '../../service/modal.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { UrlServices } from 'src/app/helper/class/url-services';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-send-msg',
  templateUrl: './send-msg.component.html',
  styleUrl: './send-msg.component.scss'
})
export class SendMsgComponent implements OnInit {
  // pageInfo : pageInfo =  { title: 'Send Whatsapp Msg', buttonShowBtn: true, button:{ title: '', url: '', icon: 'pi pi-plus'}}
  isModal: boolean = false;
  loading: boolean = false;
  basicFormData = cloneData(WHATSAPP_SEND);
  dataForms: any;
  urlService = UrlServices.PAGE_URL;
  @ViewChild('basicForm') basicForm: FormGeneratorComponent | undefined;
  public onClose: Subject<boolean> = new Subject();
  mobileNo: any;
  _bsModalRef: BsModalRef = {} as BsModalRef;
  constructor(private masterApi: MasterApiService,
    private modalService: ModalService,
    private router: Router, private alertService: AlertService,
    private injector: Injector) { }

  ngOnInit(): void {
  }

  setInput(data: any) {
    this._bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    this.isModal = true
    const d = { mobile_no: data?.mobile_no || '', message: data?.message || '' }
    this.basicForm?.setData(d)
  }
  apiPayload() {
    const payload = this.basicForm?.apiPayload();
    return payload
  }
  get valid() {
    return this?.basicForm?.isValid() || false;
  }
  onSubmit() {
    this.loading = true;
    this.masterApi.WhatsappMsg(this.apiPayload()).then((res: any) => {
      if (res) {
        this.alertService.showToast("successfully Send", 'success');
        this.close()
      }
    }).finally(() => this.loading = false)
  }

  onChange(e: any) {

  }
  close() {
    if (this.isModal) {
      this._bsModalRef.hide()
    }
  }
}
